import JSONModel from "sap/ui/model/json/JSONModel";
import { Routes } from "../../constants/Routes";
import BaseController from "../sharedControllers/BaseController";
import { CreateContractDto } from "../../models/CreateContractDto";
import { IsUserInternal } from "../../services/AuthService";

/**
 * @namespace akademika.akamont.pages.contractDetails
 */

export default class ContractDetails extends BaseController {
  route = Routes.CONTRACT_DETAILS;
  parentRoute = Routes.CONTRACT_LIST;

  getContractDetailsUri = "api/Contract/GetContractDetails/{id}";
  editContractUri = "api/Contract/UpdateContract/{id}";
  contractDeleteUri = "api/Contract/DeleteContract/{id}";
  id = "0";

  public async onRouteMatched() {
    this.fetchModel(
      "api/Contract/GetBusinessUnitOptions",
      "businessUnitOptions"
    );

    this.setModel(
      new JSONModel({
        edit: false,
      }),
      "viewOptions"
    );
    this.id = this.routeParams.id;
    await this.getContractDetails();
  }

  private async getContractDetails() {
    const uri = this.getContractDetailsUri.replace("{id}", this.id);
    await this.fetchModel(uri);
  }

  public onEditContract() {
    this.getModel("viewOptions").setProperty("/edit", true);
  }

  public async onCancelEdit() {
    this.getModel("viewOptions").setProperty("/edit", false);
    await this.getContractDetails();
  }

  public async onSaveContract() {
    const requestData = this.getModelData<CreateContractDto>();
    const uri = this.editContractUri.replace("{id}", this.id);
    await this.saveDataAndShowMessage(uri, {
      body: requestData,
    });

    const model = this.getModel("viewOptions");
    model.setProperty("/edit", false);
    await this.getContractDetails();
  }

  public async onDeleteContract() {
    const uri = this.contractDeleteUri.replace("{id}", this.id);
    await this.saveDataAndShowMessage(uri);
    await this.getContractDetails();
  }

  public onWorkOrderDetails(workOrderId: number) {
    this.navTo(
      IsUserInternal()
        ? Routes.WORK_ORDER_DETAILS_INTERNAL
        : Routes.WORK_ORDER_DETAILS_PARTNER,
      { workOrderId }
    );
  }
}
